module.exports = __webpack_public_path__ + "img/javascript_sign.09493137.png";